import React, { useContext, useRef, useState } from 'react'
import { Animated, Easing, TouchableOpacity, View } from 'react-native'
import { AntDesign } from '@expo/vector-icons'
import { textStyles } from '../style'
import HorizontalList from '../horizontal-list'
import Alternatives from './alternatives'
import { ContentProps } from './types'
import { ThemeContext } from '../utility/context/ThemeContext'
import AutoShrinkText from '../utility/AutoShrinkText'

export const ProfileContent: React.FC<ContentProps> = ({
  company,
  sortedUserValues,
  fetchingUserScores,
  showAlternatives,
}: ContentProps) => {
  const [expanded, setExpanded] = useState(false)

  const theme = useContext(ThemeContext).theme
  const { textMain } = theme.colors
  
  const animatedValue = useRef(new Animated.Value(0)).current

  const rotate = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '90deg']
  })
  
  const expandedHeight = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 300]
  })

  const toggleExpanded = () => {
    Animated.timing(animatedValue, {
      toValue: expanded ? 0 : 1,
      duration: 300,
      easing: Easing.linear,
      useNativeDriver: false
    }).start()
    setExpanded((prev) => !prev)
  }

  const {
    name,
    brands,
    corporate_parent,
    corporate_parent_id
  } = company

  return (
    <View>
      {/* wrapper to support blur modal */}
      <View style={{ flexDirection: 'row' }}>
        <View style={{ flex: 1 }}>
          {brands && !!brands.length && (
            <View>
              <TouchableOpacity
                style={{
                  flex: 1,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 10,
                }}
                onPress={toggleExpanded}
              >
                <AutoShrinkText
                  text={`Brands Owned by ${corporate_parent || name} (${brands.length})`}
                  textStyle={[textStyles.h4, { color: textMain }]}
                  containerStyle={{ flexShrink: 1 }}
                />
                <Animated.View style={{ transform: [{rotate}]}}>
                  <AntDesign
                    name={"right"}
                    size={16}
                    color={textMain}
                  />
                </Animated.View>
              </TouchableOpacity>
              <Animated.View style={{ overflow: "hidden", maxHeight: expandedHeight }}>
                <HorizontalList
                  id={`${company._id}-brands`}
                  companies={brands}
                  addlProfileParams={{
                    source: (corporate_parent ? 'sibling company' : 'corporate parent'),
                    sourceCompanyId: company._id,
                    sourceCompanyName: company.name,
                    parentCompanyId: corporate_parent_id?.toString() ?? undefined,
                    parentCompanyName: corporate_parent ?? undefined
                  }}
                />
              </Animated.View>
            </View>
          )}

          <View style={{ height: 20 }}>{/* vertical padding */}</View>
          {company ? (
            <Alternatives company={company} showAlternatives={showAlternatives} />
          ) : null}
        </View>
      </View>
    </View>
  )
}

export default ProfileContent
